import { j as s } from "./AccesRecoveryIcon-CUPieIxT.js";
const o = () => /* @__PURE__ */ s.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 5.76 5.76", children: /* @__PURE__ */ s.jsx("path", { d: "m2.413 1.917 1.351 1.926h-.359L2.056 1.917zM5.04 5.04H.72V.72h4.32zm-.831-.96L3.204 2.642l.822-.962h-.315l-.649.758-.53-.758h-.924l.946 1.352-.897 1.048h.32l.72-.844.591.844z" }) });
export {
  o as X
};
